export default "__VITE_ASSET__Dov1SGtI__"